import { readSessionStorage } from '../../appSettings/app.environment';
import type { SessionIdentity } from './sessionTermination.types';

/**
 * Answers "which backend session is this tab signed in with?".
 *
 * Callers never pass a session id in; it is read here, at the moment it is
 * needed, so a tab that has signed out and back in cannot act on a stale id
 * captured earlier.
 */
export class SessionDirectory {
  /** @returns the signed-in session, or `undefined` when this tab has none. */
  current(): SessionIdentity | undefined {
    const { sessionId, systemId } = readSessionStorage();

    // Storage is empty until sign-in completes, so the declared types are not
    // yet true. A partial identity cannot be matched against a peer's, so it
    // cannot take part in coordination at all.
    if (!sessionId || !systemId) return undefined;

    return { sessionId, systemId };
  }
}
